export default "__VITE_ASSET__BFK6JApr__"